import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { AuftragEx, AuftragspositionEx } from 'src/app/api/model/model';
import { ModalController, IonSelect, IonSearchbar } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Subscription, BehaviorSubject } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { Artikel, AdresseEntity, GpsPosition, MengeOptionTyp, Vertragsposition, Wiegedaten } from 'src/app/api/model/swagger-model';

import { AppConfig } from 'src/app/api/helper/app.config';
import { Utils } from 'src/app/api/helper/utils';
import { AuftragLieferungDetailsPage } from '../auftrag-lieferung-details/auftrag-lieferung-details.page';
import { IAuftragdetails } from '../auftragdetails/iauftragdetails';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Constants } from 'src/app/api/model/constants';

@Component({
    selector: 'app-auftragsposition-wiegen-popup',
    templateUrl: './auftragsposition-wiegen-popup.page.html',
    styleUrls: ['./auftragsposition-wiegen-popup.page.scss'],
    standalone: false
})
export class AuftragspositionWiegenPopupPage implements OnInit, AfterViewInit, OnDestroy {
    log = new Logger("AuftragspositionWiegenPopupPage");

    @ViewChild('content', { static: false }) content: any;
    @ViewChild('wiegungenSelect', { read: IonSelect, static: false }) wiegungenSelect: IonSelect;
    @ViewChild('searchbar', { static: false }) searchbar: IonSearchbar;
    @ViewChild('auftragLieferungDetails', { static: false }) auftragLieferungDetails: AuftragLieferungDetailsPage;

    @Input() auftrag: AuftragEx;
    @Input() auftragdetails: IAuftragdetails;
    @Input() auftragsposition: AuftragspositionEx;

    subscriptions: Subscription[] = [];
    leavWurdeAufgerufen = false;

    dayNames = Constants.dayNames;
    wiegedatenListe: Wiegedaten[] = [];

    positionsEigenschaftenImmerAnzeigen = false;

    title = 'Wiegen';

    positionHinzufuegenErlaubt = true;

    constructor(
        private auftragService: AuftragService,
        private modalController: ModalController,
        private cdr: ChangeDetectorRef) { }

    async ngOnInit() {
        this.subscriptions.push(this.auftragService.aktuellerauftragWurdeGeaendert.subscribe(() => {
            this.dismiss();
        }));
    }

    ngAfterViewInit() {
    }

    ionViewDidEnter() {
        MyApp.current.backAction = () => this.onAbbrechen();

        this.auftragService.setzeAktivenAuftrag(this.auftrag, 'lieferung');
    }

    async ionViewWillLeave() {
        this.log?.debug('ionViewWillLeave');

        this.leavWurdeAufgerufen = true;

        MyApp.current.backAction = null;

        if (this.auftragLieferungDetails) {
            this.auftragLieferungDetails.aktualisiereAuftrag();
        }

        if (this.auftragService.istAktiverAuftrag(this.auftrag)) {
            await Utils.delay(50);

            await this.auftragService.speichereAuftrag(this.auftrag);

            // this.auftragService.setzeAktivenAuftrag(null, 'lieferung exit');
        } else {
            this.log.warn('ionViewWillLeave: nicht aktiver Auftrag ' + this.auftrag.Key);
        }
    }

    /**
     * Runs when the page is about to be destroyed and have its elements removed.
     */
    ngOnDestroy() {
        this.log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        if (!this.leavWurdeAufgerufen) {
            // Das tritt normalerweise nur im wizard-Modus auf.
            // hier fehlt das ionWillLead-Event
            this.ionViewWillLeave();
        }
    }

    async onAbbrechen() {
        this.log?.debug('onAbbrechen');
        await this.doSpeichern();
    }

    async onSpeichern() {
        this.log?.debug('onSpeichern');
        this.doSpeichern();
    }

    async doSpeichern() {
        this.log?.info('doSpeichern: ' + this.auftrag.Key, this.auftrag);
        this.dismiss();
    }

    onWiegungChanged() {
        // if (vo.auftragsposition.Wiegungen2) {
        //     if (vo.auftragsposition.NettoGewicht) {
        //         // Beide Wiegungen erfolgreich
        //         this.berechneMengeAusNettoGewicht(vo);
        //     }
        // }
    }

    onReset() {
    }

    dismiss() {
        this.modalController.dismiss({
            'dismissed': true
        });
    }
}
